import { useSelector } from "react-redux";
import { selectCurrentUser, selectUserLoading, selectUserError } from "../../redux/slices/userSlice";

const PageShell = ({ children }) => (
    <div className="data-upload-container">
        <div className="upload-data-header fill--1 profile-header">
            <h1 className="u-mt0 u-mb0 profile-header__title">Profile</h1>
        </div>
        {children}
    </div>
);

const StateCard = ({ message }) => (
    <div className="profile-page-body">
        <div className="profile-card profile-card--state">
            <p className="profile-state-msg">{message}</p>
        </div>
    </div>
);

const ProfilePage = () => {
    const currentUser = useSelector(selectCurrentUser);
    const isLoading = useSelector(selectUserLoading);
    const error = useSelector(selectUserError);

    const dataProviderNames = Array.isArray(currentUser?.DataProviderDisplayName)
        ? currentUser.DataProviderDisplayName
        : currentUser?.DataProviderDisplayName
            ? [currentUser.DataProviderDisplayName]
            : [];

    if (isLoading) {
        return (
            <PageShell>
                <StateCard message="Loading profile..." />
            </PageShell>
        );
    }

    if (error) {
        return (
            <PageShell>
                <StateCard
                    message="We couldn't load your profile. Please check with your administrator to confirm your account has been onboarded and given access."
                />
            </PageShell>
        );
    }

    if (!currentUser) {
        return (
            <PageShell>
                <StateCard message="No profile data available. Please log in." />
            </PageShell>
        );
    }

    return (
        <PageShell>
            <div className="profile-page-body">
                <div className="profile-card">
                    <section className="profile-card__details">
                        <div className="profile-card__details-header">
                            <h3 className="profile-card__section-title">Profile details</h3>
                        </div>

                        <div className="profile-card__rows">
                            <div className="profile-card__row">
                                <span className="profile-card__row-label-wrap">
                                    <span className="profile-card__row-label">Email address</span>
                                </span>
                                <span className="profile-card__row-value profile-card__row-value--single-line">{currentUser?.Email || '—'}</span>
                            </div>
                            <div className="profile-card__row">
                                <span className="profile-card__row-label-wrap">
                                    <span className="profile-card__row-label">Role</span>
                                </span>
                                <span className="profile-card__row-value">{currentUser?.Role || '—'}</span>
                            </div>
                            <div className="profile-card__row profile-card__row--providers">
                                <span className="profile-card__row-label-wrap">
                                    <span className="profile-card__row-label">Data Providers</span>
                                </span>
                                {dataProviderNames.length > 0 ? (
                                    <div className="profile-card__providers-content">
                                        <div className="profile-card__badges">
                                        {dataProviderNames.map((name, index) => (
                                            <span key={`${name}-${index}`} className="profile-chip">{name}</span>
                                        ))}
                                        </div>
                                    </div>
                                ) : (
                                    <span className="profile-card__row-value">No assignments available</span>
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </PageShell>
    );
};

export default ProfilePage;